import { useConfirmService } from '@onesource/components';
import type { TBlockUserBody } from '@onesource/schemas';
import { useBlockUserMutation } from '@onesource/services';
import { useCallback } from 'react';

export const BLOCK_USER_CONFIRM_MESSAGE =
  "You won't see their posts, comments or reactions, and they won't be able to see or interact with your content or mention you. They won't be notified. You can unblock them anytime from Account → Security and Privacy.";

/**
 * Opens the block confirmation and blocks the user on confirm. Shared by the
 * post / comment ⋯ menus and the Blocked Users settings section.
 */
export const useBlockUserConfirm = () => {
  const { setConfirm } = useConfirmService();
  const { mutateAsync } = useBlockUserMutation();

  return useCallback(
    (target: TBlockUserBody, name: string, onBlocked?: () => void) => {
      setConfirm({
        open: true,
        title: `Block ${name}?`,
        message: BLOCK_USER_CONFIRM_MESSAGE,
        confirmBtnLabel: 'Block',
        cancelBtnLabel: 'Cancel',
        onConfirm: async () => {
          await mutateAsync(target);
          onBlocked?.();
        },
      });
    },
    [setConfirm, mutateAsync],
  );
};
